import { Handle, Position } from '@xyflow/react';
import { RoleBadge } from '../../shared';

export function EntryNode({ data, targetPosition = Position.Left }) {
  return (
    <div className="flow-node flow-node-entry" title={data.skill || data.attitude}>
      <Handle
        type="target"
        position={targetPosition}
        className="flow-handle"
      />

      <div className="flow-node-content">
        {data.skill && (
          <div className="entry-node-field">
            <span className="entry-node-label">Skill:</span>
            <span className="entry-node-value">{data.skill}</span>
          </div>
        )}
        {data.attitude && (
          <div className="entry-node-field">
            <span className="entry-node-label">Attitude:</span>
            <span className="entry-node-value">{data.attitude}</span>
          </div>
        )}
        {data.roles?.length > 0 && (
          <div className="entry-node-roles">
            {data.roles.map((role, idx) => (
              <RoleBadge key={idx} role={role} variant="panel" />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
